import { createStructuredSelector } from 'reselect';
import { func, shape, bool } from 'prop-types';
import { fetchCardData, fetchNsdlM2pTransactionLimits, updateNsdlM2pTransactionLimits } from './actions';
import { select_card_data } from '../NetworkCards/selectors';
import { selectNsdlTransaction, updateNsdlTransactionLimits, isTransactionLimitsLoading } from './selectors';


/**
 * @class NsdlTransactionLimits
 */

const NsdlTransactionLimitsPropTypes = {
  isTransactionLimitsLoading: bool.isRequired,
  cardData: shape({}).isRequired,
  fetchNsdlM2pLimits: shape({}).isRequired,
  updateNsdlM2pLimits: shape({}).isRequired,
  onFetchCardData: func.isRequired,
  onFetchNsdlM2pTransactionLimits: func.isRequired,
  onUpdateNsdlM2pTransactionLimits: func.isRequired,
};


const NsdlTransactionLimitsMapDispatchToProps = (dispatch) => ({
  onFetchCardData: (payload) => dispatch(fetchCardData(payload)),
  onFetchNsdlM2pTransactionLimits: () => dispatch(fetchNsdlM2pTransactionLimits()),
  onUpdateNsdlM2pTransactionLimits: (payload) => dispatch(updateNsdlM2pTransactionLimits(payload)),
});

const NsdlTransactionLimitsMapStateToProps = createStructuredSelector({
  cardData: select_card_data(),
  fetchNsdlM2pLimits: selectNsdlTransaction(),
  updateNsdlM2pLimits: updateNsdlTransactionLimits(),
  isTransactionLimitsLoading: isTransactionLimitsLoading(),
});

export {
  NsdlTransactionLimitsPropTypes,
  NsdlTransactionLimitsMapDispatchToProps,
  NsdlTransactionLimitsMapStateToProps,
};



// WEBPACK FOOTER //
// client/containers/NsdlTransactionLimits/NsdlTransactionLimitsDatahandler.js